// extracted by mini-css-extract-plugin
export default {"setDueDateForm":"SetDueDate_setDueDateForm__rxrrE"};